import ValentinePack from "../../../Assets/Images/MiniPackages/Valentine Pack.png";
import LifeStylePack from "../../../Assets/Images/MiniPackages/Life Style Pack.png";
import WorldNewsPack from "../../../Assets/Images/MiniPackages/World News.png";
import SportPack from "../../../Assets/Images/MiniPackages/Sport Pack.png";
import KidsPack from "../../../Assets/Images/MiniPackages/Kids Pack.png";

export const cards = [
  {
    id: 1,
    name: "Valentine Pack",
    description: "For Lovers",
    price: "5.99",
    image: ValentinePack,
    backgroundColor: "#DE1E17",
  },
  {
    id: 2,
    name: "Life Style Pack",
    description: "For Food Lovers",
    price: "5.99",
    image: LifeStylePack,
    backgroundColor: "#22AF03",
  },
  {
    id: 3,
    name: "World News",
    description: "All Around the World",
    price: "5.99",
    image: WorldNewsPack,
    backgroundColor: "#2117DE",
  },
  {
    id: 4,
    name: "Sport Pack",
    description: "For Sport Lovers",
    price: "5.99",
    image: SportPack,
    backgroundColor: "#C304A6",
  },
  {
    id: 5,
    name: "Kids Pack",
    description: "For Kids",
    price: "5.99",
    image: KidsPack,
    backgroundColor: "#DE7117",
  },
  {
    id: 6,
    name: "Valentine Pack",
    description: "For Lovers",
    price: "5.99",
    image: ValentinePack,
    backgroundColor: "#DE1E17",
  },
  {
    id: 7,
    name: "Life Style Pack",
    description: "For Food Lovers",
    price: "5.99",
    image: LifeStylePack,
    backgroundColor: "#22AF03",
  },
  {
    id: 8,
    name: "World News",
    description: "All Around the World",
    price: "5.99",
    image: WorldNewsPack,
    backgroundColor: "#2117DE",
  },
  {
    id: 9,
    name: "Sport Pack",
    description: "For Sport Lovers",
    price: "5.99",
    image: SportPack,
    backgroundColor: "#C304A6",
  },
  {
    id: 10,
    name: "Kids Pack",
    description: "For Kids",
    price: "5.99",
    image: KidsPack,
    backgroundColor: "#DE7117",
  },
];
